import React from "react";
import "./SkeletonDashBoardCard.css"; // Import the CSS file for styling

const SkeletonDashBoardCard = () => {
  return (
    <div className="col-md-4">
      <div className="dbCard p-3 mb-4 d-flex flex-column justify-content-center card-shadow">
        <div className="skeleton skeleton-text mb-2"></div>
        <div className="skeleton skeleton-subtext mb-2"></div>
        <div className="skeleton skeleton-data"></div>
      </div>
    </div>
  );
};

export default SkeletonDashBoardCard;
